import React from 'react'
import { ReactComponent as PreloaderImage } from './assets/img_loader.svg'
import './assets/Preloader.scss'

const Preloader: React.FC<{}> = () => (
  <div className="preloader">{<PreloaderImage />}</div>
)

export default Preloader
